import { CloudDownloadOutlined, DeleteOutlined } from "@ant-design/icons";
import { Space, Table } from "antd";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useCallback, useEffect, useState } from "react";
import { GetProcedimientoSeguro } from "../../Service/Service.porcedimientos";
import EliminarFactura from "../Factura/Listar/EliminarFactura";
import { ControllerSoporteByProcedimiento } from "../../Service/Service.soporte";

function GridSoporteListado({data}) {

    const { filters } = data;

    const [loading, setLoading] = useState(false);
    const [proceduresList, setProceduresList] = useState([]);
    const [showDeleteInvoice, setShowDeleteInvoice] = useState(false);
    
    const [dataInvoice, setDataInvoice] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);

    const columns = [
        {
            title: 'Fecha',
            dataIndex: 'fecha_emision',
            key: 'fecha_emision',
            width: 120,
            width: 100,
            render: (_, record) => (
                <>
                    {format(new Date(record.fecha_emision), "dd/MM/yyyy", { locale: es })}
                </>
            ), 
        },
        {
            title: 'Paciente',
            dataIndex: ['paciente', 'nombres_completos'],
            key: 'paciente.nombres_completos',
            width: 200,
        },    
        {
            title: 'Procedimiento',
            dataIndex: ['ExamenTipo', 'descripcion'],
            key: 'ExamenTipo.descripcion',
            width: 200,
        },              
        {
            title: 'Seguro',
            dataIndex: ['Seguros', 'nombre'],
            key: 'Seguros.nombre'
        },
        // {
        //     title: 'Cantidad',
        //     dataIndex: 'cantidad',
        //     key: 'cantidad',
        //     align: 'right',
        //     width: 80,
        //     render: (_, record) => (
        //         <>
        //             {record.cantidad.toFixed(2)}
        //         </>
        //     ), 
        // },
        // {
        //     title: 'Precio',
        //     dataIndex: 'precio',
        //     key: 'precio',
        //     align: 'right',
        //     width: 80,
        //     render: (_, record) => (
        //         <>
        //             {record.precio.toFixed(2)}
        //         </>
        //     ), 
        // },
        {
            title: 'Estado',
            dataIndex: 'estado',
            key: 'estado',
            width: 150,
        },
        {
            title: 'Acciones',
            key: 'action',
            width: 80,
            render: (_, record) => {
                
                return (
                    <Space size="middle">
                        <CloudDownloadOutlined title="Descargar ZIP" style={{ cursor: 'pointer' } } onClick={() => handleDownloadZIPbyProcedure(record)}/>
                    </Space>
                );
            }
        }                    
    ];   

    const fetchInitialData = useCallback(async (page = 1, limit = 10, filters) => {
        
        setLoading(true);
        const result = await GetProcedimientoSeguro({ page, limit, filters });

        if (result && !result.success) {
            const fetchInvoice = result.data.map((item, index) => ({
                ...item,
                key: item.idprocedimiento_cita_paciente,
                index
            }));
            setProceduresList(fetchInvoice);

            setTotal(result.pagination.total);
            setCurrentPage(result.pagination.page);
            setPageSize(result.pagination.limit);
        }

        setLoading(false);
    }, []);

    const handleConfirmDelete = () => {
        fetchInitialData();
    }

    const handleCloseDelete = () => {
        setShowDeleteInvoice(!showDeleteInvoice);
    }

    const handleDownloadZIPbyProcedure = async (record) => {        
        try {
            setLoading(true);
            const result = await ControllerSoporteByProcedimiento(record.idprocedimiento_cita_paciente);
            if (!result.success) {
                
            }

        } catch (error) {
            console.error('Error al generar el ZIP 2:',error);
        } finally {

            setLoading(false);
        }
    } 

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        fetchInitialData(current, pageSize, filters);
    };

    useEffect(() => {
        fetchInitialData(currentPage, pageSize,filters);
    }, [fetchInitialData, filters, currentPage, pageSize]);

    return (
        <>
            <Table loading={loading} 
                columns={columns} 
                size='small' 
                scroll={{ x: "max-content", y: 500 }}
                onChange={handleTableChange}
                pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total ${total} Procedimientos`,
                }}
                dataSource={proceduresList}
            />

            <EliminarFactura
                data={{
                    show: showDeleteInvoice,
                    handleClose: handleCloseDelete,
                    invoice: dataInvoice,
                    handleConfirmDelete: handleConfirmDelete
                }}
            />
        </>
    )
}

export default GridSoporteListado